import { useContext, useEffect, useState } from "react";
import { useApi } from "../../hooks/useApi";
import { InvoiceReadType, NotificationContextType } from "../../types";
import { NotificationContext } from "../../components/NotificationPane";
import { Box, Card, CardBody, Table, TableContainer, Tag, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

type InvoiceReadsSectionProps = {
    invoice_number: string,
    supplier_code: string,
    supply_number: string
}

function InvoiceReadsSection({invoice_number, supplier_code, supply_number}: InvoiceReadsSectionProps) {
    const { ready, getInvoiceReads } = useApi();
    const { pushNotification } = useContext<NotificationContextType | null>(NotificationContext)!;
    const [invoiceReads, setInvoiceReads] = useState<InvoiceReadType[] | undefined>(undefined);

    useEffect(() => {
        async function loadReads() {
            try {
                const response = await getInvoiceReads(invoice_number, supplier_code);
                setInvoiceReads(response);
            } catch(err) {
                pushNotification("Could not load invoice.", "error")
            }
        }
        if (ready && invoice_number && supplier_code)
            loadReads();
    }, [ready, invoice_number, supplier_code]);


    if (!invoiceReads) return <div>Loading...</div>;

    const filteredInvoiceReads =  invoiceReads.filter(r => r.supply_number === supply_number);

    return (
        <Box w="100%">
            <Card>
                <CardBody>
                    <TableContainer>
                        <Table variant="simple" size="sm">
                            <Thead>
                                <Th>Period</Th>
                                <Th>Meter</Th>
                                <Th>Prev Read</Th>
                                <Th>Curr Read</Th>
                                <Th>Consumption</Th>
                            </Thead>
                            <Tbody>
                                {filteredInvoiceReads.map((r, idx) => (
                                    <Tr key={idx}>
                                        <Td>
                                            {r.read_prev_date && r.read_curr_date
                                            ? `${new Date(r.read_prev_date).toLocaleDateString()} → ${new Date(r.read_curr_date).toLocaleDateString()}`
                                            : 'Unknown'}
                                        </Td>
                                        <Td>{r.rate_description}</Td>
                                        <Td><Tag size="sm">{r.read_prev_aei}</Tag> {r.read_prev} </Td>
                                        <Td><Tag size="sm">{r.read_curr_aei}</Tag> {r.read_curr}</Td>
                                        <Td><Tag size="sm">{r.cons_meter_aei}</Tag> {r.cons_meter} {r.meter_uom}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </CardBody>
            </Card>
        </Box>
    );
}

export default InvoiceReadsSection